<template>
  <div class="auth-block">
    <template v-if="isAuth && flow !== $options.FLOW.TRIAL">
      <div class="block">
        <logged-on />
      </div>
    </template>

    <template v-else>
      <div v-if="flow !== $options.FLOW.TRIAL" class="info-message valid pb-10">
        <v-icon class="sr-icon-check"/>
        <span v-html="$t('auth.registrationAlert') + ':'"></span>
      </div>

      <v-expand-transition>
        <registration
            v-show="logIn"
            @getLogIn="getLogIn($event)"
            ref="registration"
            :flow="flow"
            :isAuth="isAuth"
            :is-virtual-hosting-v2="isVirtualHostingV2"
        />
      </v-expand-transition>
      <v-expand-transition>
        <login
            v-show="!logIn"
            @getLogOut="getLogOut($event)"
            ref="login"
            :flow="flow"
            :is-virtual-hosting-v2="isVirtualHostingV2"
        />
      </v-expand-transition>
    </template>
  </div>
</template>

<script>
  import { FLOW } from '@/constants';
  import LoggedOn from "./LoggedOn.vue";
  import Registration from "./Registration.vue";
  import Login from "./LogIn.vue";

  export default {
    name: "Authorization",
    FLOW,
    components: {
      LoggedOn,
      Registration,
      Login,
    },
    props: {
      isAuth: { type: Boolean, default: false },
      flow: { type: String },
      isVirtualHostingV2: { type: Boolean, default: false },
    },
    data() {
      return {
        logIn: true,
        logOut: false,
      }
    },
    methods: {
      getLogIn(val) {
        this.logIn = false;
        this.logOut = val;
      },
      getLogOut(val) {
        this.logOut = false;
        this.logIn = val;
      },
      submit() {
        return this.logIn ? !this.$refs.registration?.submit() : !this.$refs.login?.submit();
      }
    }
  }
</script>

<style lang="scss">
  .auth-block {

    form {

      .row {
        padding-bottom: 12px;

        @media (max-width: $desktop) {

          [class*="col-"]:not(:last-child), [class*="col-"]:not(:last-child) {
            padding-bottom: $row-padding;
          }
        }
      }
    }
  }
</style>
